import { render, staticRenderFns } from "./HeaderLogoutButton.vue?vue&type=template&id=eda5f6be"
import script from "./HeaderLogoutButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderLogoutButton.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports